<template >
    <div class="container-fluid" v-if="student">

      <div class="card mb-4" >
        <div class="card-header py-3">
          <div class="row">
            <div class="col col-expand">
              <h4 class="m-0 font-weight-bold text-primary">{{student.name}},  {{student.code}} багш мэдээлэл</h4>
            </div>

          </div>
        </div>
        <div class="card-body">
          <p>Нэр: {{student.name}}</p>
          <p>Овог: {{student.lastname}}</p>
          <p >Багш код: {{student.code}}</p>
          <p >Имэйл: {{student.email}}</p>
          <p >Утасны дугаар: {{student.phone}}</p>
          <p v-if="student.school">Сургууль: {{student.school.id}}</p>
          <p v-if="student.department">Xөтөлбөрийн баг: {{student.department.id}}</p>

        </div>

      </div>

      <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Хичээл</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Ном</a>
        </li>

      </ul>
      <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
          <teacher-lessons :teacherPath="'teachers/'+student.id"></teacher-lessons>
        </div>
        <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
          <div class="card">
            <div class="card-header">
              <h4>Ном</h4>
            </div>
            <div class="card-body">
              <div class="table-responsive" v-if="books && books.length>0">
                <table class="table table-sm table-bordered">
                  <tr>
                    <th>№</th>
                    <th>Нэр</th>
                    <th>Үйлдэл</th>
                  </tr>
                  <tr v-for="(book, index) in books">
                    <td>{{index+1}}. </td>
                    <td>{{book.title}}</td>
                    <td>
                      <ul style="list-style:none;" v-if="book.files && book.files.length>0">
                        <li v-for="file in book.files" v-if="file && file.fileUrl">
                          <a target="blank" :href="file.fileUrl" class="text-white btn btn-info btn-sm">Татах</a>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </table>
              </div>
              <div v-else class="alert alert-info">Одоогоор ном оруулаагүй байна.</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment';
import TeacherLessons from "./TeacherLessons";

export default {
    name: "TeacherDetail",
    components: {
      'teacher-lessons': TeacherLessons
    },
    data() {
        return {
            student: null,
            semesters:[],
            value: null,
            selectedSemester:null,
            books:[]
        };
    },
    methods: {  
      _getStudent(){

        fb.db.collection("teachers").doc(this.studentId).get().then(doc=> {
            let student=doc.data();
            student.id=doc.id;
            this.student=student;

            fb.db.collectionGroup("books").where("teacher","==", doc.ref).get().then(querysnapshot=>{
              this.books=[];
              if(querysnapshot && !querysnapshot.empty){
                querysnapshot.docs.forEach(bookDoc=>{
                  let item=bookDoc.data();
                  item.id=bookDoc.id;
                  this.books.push(item);
                });
              }
            });
        });


      },

      setProperty(propertyName, object, value){
  
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.set(tmp,{merge:true});
        }
      },

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        studentId: { 
            required: true,
        }
    },
    created() {
      if(this.studentId!=null && this.studentId!='')
        this._getStudent();
          
    },
    filters: {
        formatDateFromNow(val) {
            if (!val) { return '-' }
            let date = val.toDate()
            return moment(date).fromNow()
        },
        formatDate(val) {
            if (!val) { return '-' }
            let date = val.toDate()
            return moment(date).format('MM/DD/YYYY HH:mm');
        },
        trimLength(val) {
            if (val.length < 200) { return val }
            return `${val.substring(0, 200)}...`
        }
    }
  
};
</script>

